import React from 'react';
import { IUnderwriterProfileSummaryData } from 'types/administration/pricing/IUnderWriterProfileSummary';
import { UnderwriterProfileTable } from 'components/administration/pricing/UnderwriterProfileTable';
import { Card, ErrorMessage, FlexRow, FormCell, Grid, Header2Text } from 'ui-toolkit/components';
import { IFetchDataState } from 'store/IFetchDataState';
import { IPaginationQuery } from 'types/rest/IPaginationQuery';

export interface IPricingAdministrationPageProps {
  fetchDataState: IFetchDataState<IPaginationQuery, IUnderwriterProfileSummaryData[]>;
}

export const PricingAdministrationPage: React.FC<IPricingAdministrationPageProps> = ({ fetchDataState }) => (
  <Grid data-test-id={'pricing-administration'}>
    {fetchDataState.fetchError && <ErrorMessage error={fetchDataState.fetchError} />}
    <Card>
      <FlexRow justifyContent={'space-between'} width={100}>
        <FormCell hintText={'The profiles of underwriters, as described by state, zone, name, and effective date'}>
          <Header2Text>Underwriter Profiles</Header2Text>
        </FormCell>
      </FlexRow>
      <UnderwriterProfileTable data={fetchDataState.data} fetchStatus={fetchDataState.fetchStatus} />
    </Card>
  </Grid>
);
